import { createSelector } from 'reselect'

const getChecklistItemById = (state, props) => {
  return state['view-card'].checklistItems[props.cardContext.id][props.id]
}

const getIsCardArchived = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].isArchived
}

const getBoardId = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].boardId
}

const getStatusId = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].statusId
}

const getIsTemplate = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].isTemplate
}

export default () => createSelector(
  [getChecklistItemById, getIsCardArchived, getBoardId, getStatusId, getIsTemplate],
  (checklistItem, isCardArchived, boardId, statusId, isTemplate) => {
    return {
      ...checklistItem,
      isCardArchived,
      boardId,
      statusId,
      isTemplate,
    }
  }
)
